// source: services/post/post.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var services_common_common_pb = require('../../services/common/common_pb.js');
goog.object.extend(proto, services_common_common_pb);
var services_account_account_pb = require('../../services/account/account_pb.js');
goog.object.extend(proto, services_account_account_pb);
var services_discussion_discussion_pb = require('../../services/discussion/discussion_pb.js');
goog.object.extend(proto, services_discussion_discussion_pb);
goog.exportSymbol('proto.social.post.AdminGetPostsRequest', null, global);
goog.exportSymbol('proto.social.post.AdminGetPostsRequest.Status', null, global);
goog.exportSymbol('proto.social.post.AdminPostActionRequest', null, global);
goog.exportSymbol('proto.social.post.AdminPostActionRequest.Action', null, global);
goog.exportSymbol('proto.social.post.AdminPostListResponse', null, global);
goog.exportSymbol('proto.social.post.AdminPostReportRequest', null, global);
goog.exportSymbol('proto.social.post.AdminPostReportRequest.Options', null, global);
goog.exportSymbol('proto.social.post.GetPostsByLocationRequest', null, global);
goog.exportSymbol('proto.social.post.GetPostsRequest', null, global);
goog.exportSymbol('proto.social.post.GetProductPostsRequest', null, global);
goog.exportSymbol('proto.social.post.GetSavedPostsRequest', null, global);
goog.exportSymbol('proto.social.post.LikeRequest', null, global);
goog.exportSymbol('proto.social.post.Post', null, global);
goog.exportSymbol('proto.social.post.PostListResponse', null, global);
goog.exportSymbol('proto.social.post.PostStat', null, global);
goog.exportSymbol('proto.social.post.RelatedTo', null, global);
goog.exportSymbol('proto.social.post.RelatedType', null, global);
goog.exportSymbol('proto.social.post.SavePostRequest', null, global);
goog.exportSymbol('proto.social.post.TogglePost', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.post.AdminPostActionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.post.AdminPostActionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.post.AdminPostActionRequest.displayName = 'proto.social.post.AdminPostActionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.post.GetProductPostsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.post.GetProductPostsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.post.GetProductPostsRequest.displayName = 'proto.social.post.GetProductPostsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.post.AdminPostReportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.post.AdminPostReportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.post.AdminPostReportRequest.displayName = 'proto.social.post.AdminPostReportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.post.RelatedTo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.post.RelatedTo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.post.RelatedTo.displayName = 'proto.social.post.RelatedTo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.post.Post = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.social.post.Post.repeatedFields_, null);
};
goog.inherits(proto.social.post.Post, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.post.Post.displayName = 'proto.social.post.Post';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.post.AdminGetPostsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.post.AdminGetPostsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.post.AdminGetPostsRequest.displayName = 'proto.social.post.AdminGetPostsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.post.AdminPostListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.social.post.AdminPostListResponse.repeatedFields_, null);
};
goog.inherits(proto.social.post.AdminPostListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.post.AdminPostListResponse.displayName = 'proto.social.post.AdminPostListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.post.PostStat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.post.PostStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.post.PostStat.displayName = 'proto.social.post.PostStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.post.PostListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.social.post.PostListResponse.repeatedFields_, null);
};
goog.inherits(proto.social.post.PostListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.post.PostListResponse.displayName = 'proto.social.post.PostListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.post.GetPostsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.post.GetPostsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.post.GetPostsRequest.displayName = 'proto.social.post.GetPostsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.post.GetSavedPostsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.post.GetSavedPostsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.post.GetSavedPostsRequest.displayName = 'proto.social.post.GetSavedPostsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.post.SavePostRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.post.SavePostRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.post.SavePostRequest.displayName = 'proto.social.post.SavePostRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.post.LikeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.post.LikeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.post.LikeRequest.displayName = 'proto.social.post.LikeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.post.GetPostsByLocationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.post.GetPostsByLocationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.post.GetPostsByLocationRequest.displayName = 'proto.social.post.GetPostsByLocationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.social.post.TogglePost = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.social.post.TogglePost, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.social.post.TogglePost.displayName = 'proto.social.post.TogglePost';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.post.AdminPostActionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.social.post.AdminPostActionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.post.AdminPostActionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.AdminPostActionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    postId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    action: jspb.Message.getFieldWithDefault(msg, 2, 0),
    reason: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.post.AdminPostActionRequest}
 */
proto.social.post.AdminPostActionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.post.AdminPostActionRequest;
  return proto.social.post.AdminPostActionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.post.AdminPostActionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.post.AdminPostActionRequest}
 */
proto.social.post.AdminPostActionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostId(value);
      break;
    case 2:
      var value = /** @type {!proto.social.post.AdminPostActionRequest.Action} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.post.AdminPostActionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.post.AdminPostActionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.post.AdminPostActionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.AdminPostActionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPostId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.social.post.AdminPostActionRequest.Action = {
  DELETE: 0,
  ARCHIVE: 1,
  PUBLISH: 2,
  UNDELETE: 3
};

/**
 * optional string post_id = 1;
 * @return {string}
 */
proto.social.post.AdminPostActionRequest.prototype.getPostId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.AdminPostActionRequest} returns this
 */
proto.social.post.AdminPostActionRequest.prototype.setPostId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Action action = 2;
 * @return {!proto.social.post.AdminPostActionRequest.Action}
 */
proto.social.post.AdminPostActionRequest.prototype.getAction = function() {
  return /** @type {!proto.social.post.AdminPostActionRequest.Action} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.social.post.AdminPostActionRequest.Action} value
 * @return {!proto.social.post.AdminPostActionRequest} returns this
 */
proto.social.post.AdminPostActionRequest.prototype.setAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string reason = 3;
 * @return {string}
 */
proto.social.post.AdminPostActionRequest.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.AdminPostActionRequest} returns this
 */
proto.social.post.AdminPostActionRequest.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.post.GetProductPostsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.social.post.GetProductPostsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.post.GetProductPostsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.GetProductPostsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    productId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    offset: jspb.Message.getFieldWithDefault(msg, 2, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.post.GetProductPostsRequest}
 */
proto.social.post.GetProductPostsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.post.GetProductPostsRequest;
  return proto.social.post.GetProductPostsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.post.GetProductPostsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.post.GetProductPostsRequest}
 */
proto.social.post.GetProductPostsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOffset(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.post.GetProductPostsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.post.GetProductPostsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.post.GetProductPostsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.GetProductPostsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string product_id = 1;
 * @return {string}
 */
proto.social.post.GetProductPostsRequest.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.GetProductPostsRequest} returns this
 */
proto.social.post.GetProductPostsRequest.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 offset = 2;
 * @return {number}
 */
proto.social.post.GetProductPostsRequest.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.GetProductPostsRequest} returns this
 */
proto.social.post.GetProductPostsRequest.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.social.post.GetProductPostsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.GetProductPostsRequest} returns this
 */
proto.social.post.GetProductPostsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.post.AdminPostReportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.social.post.AdminPostReportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.post.AdminPostReportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.AdminPostReportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    option: jspb.Message.getFieldWithDefault(msg, 1, 0),
    start: (f = msg.getStart()) && services_common_common_pb.Date.toObject(includeInstance, f),
    end: (f = msg.getEnd()) && services_common_common_pb.Date.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.post.AdminPostReportRequest}
 */
proto.social.post.AdminPostReportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.post.AdminPostReportRequest;
  return proto.social.post.AdminPostReportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.post.AdminPostReportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.post.AdminPostReportRequest}
 */
proto.social.post.AdminPostReportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.social.post.AdminPostReportRequest.Options} */ (reader.readEnum());
      msg.setOption(value);
      break;
    case 2:
      var value = new services_common_common_pb.Date;
      reader.readMessage(value,services_common_common_pb.Date.deserializeBinaryFromReader);
      msg.setStart(value);
      break;
    case 3:
      var value = new services_common_common_pb.Date;
      reader.readMessage(value,services_common_common_pb.Date.deserializeBinaryFromReader);
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.post.AdminPostReportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.post.AdminPostReportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.post.AdminPostReportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.AdminPostReportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOption();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getStart();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      services_common_common_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getEnd();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      services_common_common_pb.Date.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.social.post.AdminPostReportRequest.Options = {
  ALL: 0
};

/**
 * optional Options option = 1;
 * @return {!proto.social.post.AdminPostReportRequest.Options}
 */
proto.social.post.AdminPostReportRequest.prototype.getOption = function() {
  return /** @type {!proto.social.post.AdminPostReportRequest.Options} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.social.post.AdminPostReportRequest.Options} value
 * @return {!proto.social.post.AdminPostReportRequest} returns this
 */
proto.social.post.AdminPostReportRequest.prototype.setOption = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional social.common.Date start = 2;
 * @return {?proto.social.common.Date}
 */
proto.social.post.AdminPostReportRequest.prototype.getStart = function() {
  return /** @type{?proto.social.common.Date} */ (
    jspb.Message.getWrapperField(this, services_common_common_pb.Date, 2));
};


/**
 * @param {?proto.social.common.Date|undefined} value
 * @return {!proto.social.post.AdminPostReportRequest} returns this
*/
proto.social.post.AdminPostReportRequest.prototype.setStart = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.post.AdminPostReportRequest} returns this
 */
proto.social.post.AdminPostReportRequest.prototype.clearStart = function() {
  return this.setStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.post.AdminPostReportRequest.prototype.hasStart = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional social.common.Date end = 3;
 * @return {?proto.social.common.Date}
 */
proto.social.post.AdminPostReportRequest.prototype.getEnd = function() {
  return /** @type{?proto.social.common.Date} */ (
    jspb.Message.getWrapperField(this, services_common_common_pb.Date, 3));
};


/**
 * @param {?proto.social.common.Date|undefined} value
 * @return {!proto.social.post.AdminPostReportRequest} returns this
*/
proto.social.post.AdminPostReportRequest.prototype.setEnd = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.post.AdminPostReportRequest} returns this
 */
proto.social.post.AdminPostReportRequest.prototype.clearEnd = function() {
  return this.setEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.post.AdminPostReportRequest.prototype.hasEnd = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.post.RelatedTo.prototype.toObject = function(opt_includeInstance) {
  return proto.social.post.RelatedTo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.post.RelatedTo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.RelatedTo.toObject = function(includeInstance, msg) {
  var f, obj = {
    typ: jspb.Message.getFieldWithDefault(msg, 1, 0),
    to: jspb.Message.getFieldWithDefault(msg, 2, ""),
    data: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.post.RelatedTo}
 */
proto.social.post.RelatedTo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.post.RelatedTo;
  return proto.social.post.RelatedTo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.post.RelatedTo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.post.RelatedTo}
 */
proto.social.post.RelatedTo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.social.post.RelatedType} */ (reader.readEnum());
      msg.setTyp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.post.RelatedTo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.post.RelatedTo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.post.RelatedTo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.RelatedTo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTyp();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getData();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional RelatedType typ = 1;
 * @return {!proto.social.post.RelatedType}
 */
proto.social.post.RelatedTo.prototype.getTyp = function() {
  return /** @type {!proto.social.post.RelatedType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.social.post.RelatedType} value
 * @return {!proto.social.post.RelatedTo} returns this
 */
proto.social.post.RelatedTo.prototype.setTyp = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string to = 2;
 * @return {string}
 */
proto.social.post.RelatedTo.prototype.getTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.RelatedTo} returns this
 */
proto.social.post.RelatedTo.prototype.setTo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string data = 3;
 * @return {string}
 */
proto.social.post.RelatedTo.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.RelatedTo} returns this
 */
proto.social.post.RelatedTo.prototype.setData = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.social.post.Post.repeatedFields_ = [11,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.post.Post.prototype.toObject = function(opt_includeInstance) {
  return proto.social.post.Post.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.post.Post} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.Post.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    caption: jspb.Message.getFieldWithDefault(msg, 2, ""),
    location: (f = msg.getLocation()) && services_common_common_pb.Location.toObject(includeInstance, f),
    account: (f = msg.getAccount()) && services_account_account_pb.Account.toObject(includeInstance, f),
    publishedAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
    archivedAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
    deletedAt: jspb.Message.getFieldWithDefault(msg, 7, 0),
    isDisabledComment: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    isDisabledStat: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    stat: (f = msg.getStat()) && proto.social.post.PostStat.toObject(includeInstance, f),
    mediaListList: jspb.Message.toObjectList(msg.getMediaListList(),
    services_common_common_pb.Media.toObject, includeInstance),
    isLiked: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    isSaved: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    previewCommentsList: jspb.Message.toObjectList(msg.getPreviewCommentsList(),
    services_discussion_discussion_pb.Discussion.toObject, includeInstance),
    relatedTo: (f = msg.getRelatedTo()) && proto.social.post.RelatedTo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.post.Post}
 */
proto.social.post.Post.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.post.Post;
  return proto.social.post.Post.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.post.Post} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.post.Post}
 */
proto.social.post.Post.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaption(value);
      break;
    case 3:
      var value = new services_common_common_pb.Location;
      reader.readMessage(value,services_common_common_pb.Location.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    case 4:
      var value = new services_account_account_pb.Account;
      reader.readMessage(value,services_account_account_pb.Account.deserializeBinaryFromReader);
      msg.setAccount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPublishedAt(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setArchivedAt(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeletedAt(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDisabledComment(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDisabledStat(value);
      break;
    case 10:
      var value = new proto.social.post.PostStat;
      reader.readMessage(value,proto.social.post.PostStat.deserializeBinaryFromReader);
      msg.setStat(value);
      break;
    case 11:
      var value = new services_common_common_pb.Media;
      reader.readMessage(value,services_common_common_pb.Media.deserializeBinaryFromReader);
      msg.addMediaList(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLiked(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSaved(value);
      break;
    case 14:
      var value = new services_discussion_discussion_pb.Discussion;
      reader.readMessage(value,services_discussion_discussion_pb.Discussion.deserializeBinaryFromReader);
      msg.addPreviewComments(value);
      break;
    case 15:
      var value = new proto.social.post.RelatedTo;
      reader.readMessage(value,proto.social.post.RelatedTo.deserializeBinaryFromReader);
      msg.setRelatedTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.post.Post.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.post.Post.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.post.Post} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.Post.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCaption();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      services_common_common_pb.Location.serializeBinaryToWriter
    );
  }
  f = message.getAccount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      services_account_account_pb.Account.serializeBinaryToWriter
    );
  }
  f = message.getPublishedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getArchivedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getDeletedAt();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getIsDisabledComment();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getIsDisabledStat();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getStat();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.social.post.PostStat.serializeBinaryToWriter
    );
  }
  f = message.getMediaListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      services_common_common_pb.Media.serializeBinaryToWriter
    );
  }
  f = message.getIsLiked();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getIsSaved();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getPreviewCommentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      services_discussion_discussion_pb.Discussion.serializeBinaryToWriter
    );
  }
  f = message.getRelatedTo();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.social.post.RelatedTo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.social.post.Post.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.Post} returns this
 */
proto.social.post.Post.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string caption = 2;
 * @return {string}
 */
proto.social.post.Post.prototype.getCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.Post} returns this
 */
proto.social.post.Post.prototype.setCaption = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional social.common.Location location = 3;
 * @return {?proto.social.common.Location}
 */
proto.social.post.Post.prototype.getLocation = function() {
  return /** @type{?proto.social.common.Location} */ (
    jspb.Message.getWrapperField(this, services_common_common_pb.Location, 3));
};


/**
 * @param {?proto.social.common.Location|undefined} value
 * @return {!proto.social.post.Post} returns this
*/
proto.social.post.Post.prototype.setLocation = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.post.Post} returns this
 */
proto.social.post.Post.prototype.clearLocation = function() {
  return this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.post.Post.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional social.account.Account account = 4;
 * @return {?proto.social.account.Account}
 */
proto.social.post.Post.prototype.getAccount = function() {
  return /** @type{?proto.social.account.Account} */ (
    jspb.Message.getWrapperField(this, services_account_account_pb.Account, 4));
};


/**
 * @param {?proto.social.account.Account|undefined} value
 * @return {!proto.social.post.Post} returns this
*/
proto.social.post.Post.prototype.setAccount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.post.Post} returns this
 */
proto.social.post.Post.prototype.clearAccount = function() {
  return this.setAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.post.Post.prototype.hasAccount = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int64 published_at = 5;
 * @return {number}
 */
proto.social.post.Post.prototype.getPublishedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.Post} returns this
 */
proto.social.post.Post.prototype.setPublishedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 archived_at = 6;
 * @return {number}
 */
proto.social.post.Post.prototype.getArchivedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.Post} returns this
 */
proto.social.post.Post.prototype.setArchivedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 deleted_at = 7;
 * @return {number}
 */
proto.social.post.Post.prototype.getDeletedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.Post} returns this
 */
proto.social.post.Post.prototype.setDeletedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional bool is_disabled_comment = 8;
 * @return {boolean}
 */
proto.social.post.Post.prototype.getIsDisabledComment = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.social.post.Post} returns this
 */
proto.social.post.Post.prototype.setIsDisabledComment = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool is_disabled_stat = 9;
 * @return {boolean}
 */
proto.social.post.Post.prototype.getIsDisabledStat = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.social.post.Post} returns this
 */
proto.social.post.Post.prototype.setIsDisabledStat = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional PostStat stat = 10;
 * @return {?proto.social.post.PostStat}
 */
proto.social.post.Post.prototype.getStat = function() {
  return /** @type{?proto.social.post.PostStat} */ (
    jspb.Message.getWrapperField(this, proto.social.post.PostStat, 10));
};


/**
 * @param {?proto.social.post.PostStat|undefined} value
 * @return {!proto.social.post.Post} returns this
*/
proto.social.post.Post.prototype.setStat = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.post.Post} returns this
 */
proto.social.post.Post.prototype.clearStat = function() {
  return this.setStat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.post.Post.prototype.hasStat = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * repeated social.common.Media media_list = 11;
 * @return {!Array<!proto.social.common.Media>}
 */
proto.social.post.Post.prototype.getMediaListList = function() {
  return /** @type{!Array<!proto.social.common.Media>} */ (
    jspb.Message.getRepeatedWrapperField(this, services_common_common_pb.Media, 11));
};


/**
 * @param {!Array<!proto.social.common.Media>} value
 * @return {!proto.social.post.Post} returns this
*/
proto.social.post.Post.prototype.setMediaListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.social.common.Media=} opt_value
 * @param {number=} opt_index
 * @return {!proto.social.common.Media}
 */
proto.social.post.Post.prototype.addMediaList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.social.common.Media, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.social.post.Post} returns this
 */
proto.social.post.Post.prototype.clearMediaListList = function() {
  return this.setMediaListList([]);
};


/**
 * optional bool is_liked = 12;
 * @return {boolean}
 */
proto.social.post.Post.prototype.getIsLiked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.social.post.Post} returns this
 */
proto.social.post.Post.prototype.setIsLiked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool is_saved = 13;
 * @return {boolean}
 */
proto.social.post.Post.prototype.getIsSaved = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.social.post.Post} returns this
 */
proto.social.post.Post.prototype.setIsSaved = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * repeated social.discussion.Discussion preview_comments = 14;
 * @return {!Array<!proto.social.discussion.Discussion>}
 */
proto.social.post.Post.prototype.getPreviewCommentsList = function() {
  return /** @type{!Array<!proto.social.discussion.Discussion>} */ (
    jspb.Message.getRepeatedWrapperField(this, services_discussion_discussion_pb.Discussion, 14));
};


/**
 * @param {!Array<!proto.social.discussion.Discussion>} value
 * @return {!proto.social.post.Post} returns this
*/
proto.social.post.Post.prototype.setPreviewCommentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.social.discussion.Discussion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.social.discussion.Discussion}
 */
proto.social.post.Post.prototype.addPreviewComments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.social.discussion.Discussion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.social.post.Post} returns this
 */
proto.social.post.Post.prototype.clearPreviewCommentsList = function() {
  return this.setPreviewCommentsList([]);
};


/**
 * optional RelatedTo related_to = 15;
 * @return {?proto.social.post.RelatedTo}
 */
proto.social.post.Post.prototype.getRelatedTo = function() {
  return /** @type{?proto.social.post.RelatedTo} */ (
    jspb.Message.getWrapperField(this, proto.social.post.RelatedTo, 15));
};


/**
 * @param {?proto.social.post.RelatedTo|undefined} value
 * @return {!proto.social.post.Post} returns this
*/
proto.social.post.Post.prototype.setRelatedTo = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.post.Post} returns this
 */
proto.social.post.Post.prototype.clearRelatedTo = function() {
  return this.setRelatedTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.post.Post.prototype.hasRelatedTo = function() {
  return jspb.Message.getField(this, 15) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.post.AdminGetPostsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.social.post.AdminGetPostsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.post.AdminGetPostsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.AdminGetPostsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    accountId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    relatedToId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    relatedToType: jspb.Message.getFieldWithDefault(msg, 6, 0),
    start: (f = msg.getStart()) && services_common_common_pb.Date.toObject(includeInstance, f),
    end: (f = msg.getEnd()) && services_common_common_pb.Date.toObject(includeInstance, f),
    searchQuery: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.post.AdminGetPostsRequest}
 */
proto.social.post.AdminGetPostsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.post.AdminGetPostsRequest;
  return proto.social.post.AdminGetPostsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.post.AdminGetPostsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.post.AdminGetPostsRequest}
 */
proto.social.post.AdminGetPostsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 4:
      var value = /** @type {!proto.social.post.AdminGetPostsRequest.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelatedToId(value);
      break;
    case 6:
      var value = /** @type {!proto.social.post.RelatedType} */ (reader.readEnum());
      msg.setRelatedToType(value);
      break;
    case 7:
      var value = new services_common_common_pb.Date;
      reader.readMessage(value,services_common_common_pb.Date.deserializeBinaryFromReader);
      msg.setStart(value);
      break;
    case 8:
      var value = new services_common_common_pb.Date;
      reader.readMessage(value,services_common_common_pb.Date.deserializeBinaryFromReader);
      msg.setEnd(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchQuery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.post.AdminGetPostsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.post.AdminGetPostsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.post.AdminGetPostsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.AdminGetPostsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getRelatedToId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRelatedToType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getStart();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      services_common_common_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getEnd();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      services_common_common_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getSearchQuery();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.social.post.AdminGetPostsRequest.Status = {
  ALL: 0,
  ACTIVE: 1,
  ARCHIVED: 2,
  DELETED: 3
};

/**
 * optional int32 offset = 1;
 * @return {number}
 */
proto.social.post.AdminGetPostsRequest.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.AdminGetPostsRequest} returns this
 */
proto.social.post.AdminGetPostsRequest.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.social.post.AdminGetPostsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.AdminGetPostsRequest} returns this
 */
proto.social.post.AdminGetPostsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string account_id = 3;
 * @return {string}
 */
proto.social.post.AdminGetPostsRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.AdminGetPostsRequest} returns this
 */
proto.social.post.AdminGetPostsRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Status status = 4;
 * @return {!proto.social.post.AdminGetPostsRequest.Status}
 */
proto.social.post.AdminGetPostsRequest.prototype.getStatus = function() {
  return /** @type {!proto.social.post.AdminGetPostsRequest.Status} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.social.post.AdminGetPostsRequest.Status} value
 * @return {!proto.social.post.AdminGetPostsRequest} returns this
 */
proto.social.post.AdminGetPostsRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string related_to_id = 5;
 * @return {string}
 */
proto.social.post.AdminGetPostsRequest.prototype.getRelatedToId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.AdminGetPostsRequest} returns this
 */
proto.social.post.AdminGetPostsRequest.prototype.setRelatedToId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional RelatedType related_to_type = 6;
 * @return {!proto.social.post.RelatedType}
 */
proto.social.post.AdminGetPostsRequest.prototype.getRelatedToType = function() {
  return /** @type {!proto.social.post.RelatedType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.social.post.RelatedType} value
 * @return {!proto.social.post.AdminGetPostsRequest} returns this
 */
proto.social.post.AdminGetPostsRequest.prototype.setRelatedToType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional social.common.Date start = 7;
 * @return {?proto.social.common.Date}
 */
proto.social.post.AdminGetPostsRequest.prototype.getStart = function() {
  return /** @type{?proto.social.common.Date} */ (
    jspb.Message.getWrapperField(this, services_common_common_pb.Date, 7));
};


/**
 * @param {?proto.social.common.Date|undefined} value
 * @return {!proto.social.post.AdminGetPostsRequest} returns this
*/
proto.social.post.AdminGetPostsRequest.prototype.setStart = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.post.AdminGetPostsRequest} returns this
 */
proto.social.post.AdminGetPostsRequest.prototype.clearStart = function() {
  return this.setStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.post.AdminGetPostsRequest.prototype.hasStart = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional social.common.Date end = 8;
 * @return {?proto.social.common.Date}
 */
proto.social.post.AdminGetPostsRequest.prototype.getEnd = function() {
  return /** @type{?proto.social.common.Date} */ (
    jspb.Message.getWrapperField(this, services_common_common_pb.Date, 8));
};


/**
 * @param {?proto.social.common.Date|undefined} value
 * @return {!proto.social.post.AdminGetPostsRequest} returns this
*/
proto.social.post.AdminGetPostsRequest.prototype.setEnd = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.post.AdminGetPostsRequest} returns this
 */
proto.social.post.AdminGetPostsRequest.prototype.clearEnd = function() {
  return this.setEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.post.AdminGetPostsRequest.prototype.hasEnd = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string search_query = 9;
 * @return {string}
 */
proto.social.post.AdminGetPostsRequest.prototype.getSearchQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.AdminGetPostsRequest} returns this
 */
proto.social.post.AdminGetPostsRequest.prototype.setSearchQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.social.post.AdminPostListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.post.AdminPostListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.social.post.AdminPostListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.post.AdminPostListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.AdminPostListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.social.post.Post.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.post.AdminPostListResponse}
 */
proto.social.post.AdminPostListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.post.AdminPostListResponse;
  return proto.social.post.AdminPostListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.post.AdminPostListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.post.AdminPostListResponse}
 */
proto.social.post.AdminPostListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.social.post.Post;
      reader.readMessage(value,proto.social.post.Post.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.post.AdminPostListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.post.AdminPostListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.post.AdminPostListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.AdminPostListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.social.post.Post.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated Post items = 1;
 * @return {!Array<!proto.social.post.Post>}
 */
proto.social.post.AdminPostListResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.social.post.Post>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.social.post.Post, 1));
};


/**
 * @param {!Array<!proto.social.post.Post>} value
 * @return {!proto.social.post.AdminPostListResponse} returns this
*/
proto.social.post.AdminPostListResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.social.post.Post=} opt_value
 * @param {number=} opt_index
 * @return {!proto.social.post.Post}
 */
proto.social.post.AdminPostListResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.social.post.Post, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.social.post.AdminPostListResponse} returns this
 */
proto.social.post.AdminPostListResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional int32 total = 2;
 * @return {number}
 */
proto.social.post.AdminPostListResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.AdminPostListResponse} returns this
 */
proto.social.post.AdminPostListResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.post.PostStat.prototype.toObject = function(opt_includeInstance) {
  return proto.social.post.PostStat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.post.PostStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.PostStat.toObject = function(includeInstance, msg) {
  var f, obj = {
    likeCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    viewCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    commentCount: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.post.PostStat}
 */
proto.social.post.PostStat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.post.PostStat;
  return proto.social.post.PostStat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.post.PostStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.post.PostStat}
 */
proto.social.post.PostStat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLikeCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setViewCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCommentCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.post.PostStat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.post.PostStat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.post.PostStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.PostStat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLikeCount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getViewCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getCommentCount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 like_count = 1;
 * @return {number}
 */
proto.social.post.PostStat.prototype.getLikeCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.PostStat} returns this
 */
proto.social.post.PostStat.prototype.setLikeCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 view_count = 2;
 * @return {number}
 */
proto.social.post.PostStat.prototype.getViewCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.PostStat} returns this
 */
proto.social.post.PostStat.prototype.setViewCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 comment_count = 3;
 * @return {number}
 */
proto.social.post.PostStat.prototype.getCommentCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.PostStat} returns this
 */
proto.social.post.PostStat.prototype.setCommentCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.social.post.PostListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.post.PostListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.social.post.PostListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.post.PostListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.PostListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.social.post.Post.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.post.PostListResponse}
 */
proto.social.post.PostListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.post.PostListResponse;
  return proto.social.post.PostListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.post.PostListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.post.PostListResponse}
 */
proto.social.post.PostListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.social.post.Post;
      reader.readMessage(value,proto.social.post.Post.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.post.PostListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.post.PostListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.post.PostListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.PostListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.social.post.Post.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Post items = 1;
 * @return {!Array<!proto.social.post.Post>}
 */
proto.social.post.PostListResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.social.post.Post>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.social.post.Post, 1));
};


/**
 * @param {!Array<!proto.social.post.Post>} value
 * @return {!proto.social.post.PostListResponse} returns this
*/
proto.social.post.PostListResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.social.post.Post=} opt_value
 * @param {number=} opt_index
 * @return {!proto.social.post.Post}
 */
proto.social.post.PostListResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.social.post.Post, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.social.post.PostListResponse} returns this
 */
proto.social.post.PostListResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.post.GetPostsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.social.post.GetPostsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.post.GetPostsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.GetPostsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    offset: jspb.Message.getFieldWithDefault(msg, 3, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 4, 0),
    accountUsername: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.post.GetPostsRequest}
 */
proto.social.post.GetPostsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.post.GetPostsRequest;
  return proto.social.post.GetPostsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.post.GetPostsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.post.GetPostsRequest}
 */
proto.social.post.GetPostsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOffset(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountUsername(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.post.GetPostsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.post.GetPostsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.post.GetPostsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.GetPostsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getAccountUsername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.social.post.GetPostsRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.GetPostsRequest} returns this
 */
proto.social.post.GetPostsRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 offset = 3;
 * @return {number}
 */
proto.social.post.GetPostsRequest.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.GetPostsRequest} returns this
 */
proto.social.post.GetPostsRequest.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.social.post.GetPostsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.GetPostsRequest} returns this
 */
proto.social.post.GetPostsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string account_username = 5;
 * @return {string}
 */
proto.social.post.GetPostsRequest.prototype.getAccountUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.GetPostsRequest} returns this
 */
proto.social.post.GetPostsRequest.prototype.setAccountUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.post.GetSavedPostsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.social.post.GetSavedPostsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.post.GetSavedPostsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.GetSavedPostsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    catId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    offset: jspb.Message.getFieldWithDefault(msg, 2, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.post.GetSavedPostsRequest}
 */
proto.social.post.GetSavedPostsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.post.GetSavedPostsRequest;
  return proto.social.post.GetSavedPostsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.post.GetSavedPostsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.post.GetSavedPostsRequest}
 */
proto.social.post.GetSavedPostsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCatId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOffset(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.post.GetSavedPostsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.post.GetSavedPostsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.post.GetSavedPostsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.GetSavedPostsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCatId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string cat_id = 1;
 * @return {string}
 */
proto.social.post.GetSavedPostsRequest.prototype.getCatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.GetSavedPostsRequest} returns this
 */
proto.social.post.GetSavedPostsRequest.prototype.setCatId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 offset = 2;
 * @return {number}
 */
proto.social.post.GetSavedPostsRequest.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.GetSavedPostsRequest} returns this
 */
proto.social.post.GetSavedPostsRequest.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.social.post.GetSavedPostsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.GetSavedPostsRequest} returns this
 */
proto.social.post.GetSavedPostsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.post.SavePostRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.social.post.SavePostRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.post.SavePostRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.SavePostRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    catId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    post: (f = msg.getPost()) && proto.social.post.Post.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.post.SavePostRequest}
 */
proto.social.post.SavePostRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.post.SavePostRequest;
  return proto.social.post.SavePostRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.post.SavePostRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.post.SavePostRequest}
 */
proto.social.post.SavePostRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCatId(value);
      break;
    case 2:
      var value = new proto.social.post.Post;
      reader.readMessage(value,proto.social.post.Post.deserializeBinaryFromReader);
      msg.setPost(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.post.SavePostRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.post.SavePostRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.post.SavePostRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.SavePostRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCatId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPost();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.social.post.Post.serializeBinaryToWriter
    );
  }
};


/**
 * optional string cat_id = 1;
 * @return {string}
 */
proto.social.post.SavePostRequest.prototype.getCatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.SavePostRequest} returns this
 */
proto.social.post.SavePostRequest.prototype.setCatId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Post post = 2;
 * @return {?proto.social.post.Post}
 */
proto.social.post.SavePostRequest.prototype.getPost = function() {
  return /** @type{?proto.social.post.Post} */ (
    jspb.Message.getWrapperField(this, proto.social.post.Post, 2));
};


/**
 * @param {?proto.social.post.Post|undefined} value
 * @return {!proto.social.post.SavePostRequest} returns this
*/
proto.social.post.SavePostRequest.prototype.setPost = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.social.post.SavePostRequest} returns this
 */
proto.social.post.SavePostRequest.prototype.clearPost = function() {
  return this.setPost(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.social.post.SavePostRequest.prototype.hasPost = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.post.LikeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.social.post.LikeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.post.LikeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.LikeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    postId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    action: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.post.LikeRequest}
 */
proto.social.post.LikeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.post.LikeRequest;
  return proto.social.post.LikeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.post.LikeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.post.LikeRequest}
 */
proto.social.post.LikeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.post.LikeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.post.LikeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.post.LikeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.LikeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPostId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAction();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string post_id = 1;
 * @return {string}
 */
proto.social.post.LikeRequest.prototype.getPostId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.LikeRequest} returns this
 */
proto.social.post.LikeRequest.prototype.setPostId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string action = 2;
 * @return {string}
 */
proto.social.post.LikeRequest.prototype.getAction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.LikeRequest} returns this
 */
proto.social.post.LikeRequest.prototype.setAction = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.post.GetPostsByLocationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.social.post.GetPostsByLocationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.post.GetPostsByLocationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.GetPostsByLocationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    lat: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    pb_long: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    offset: jspb.Message.getFieldWithDefault(msg, 3, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.post.GetPostsByLocationRequest}
 */
proto.social.post.GetPostsByLocationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.post.GetPostsByLocationRequest;
  return proto.social.post.GetPostsByLocationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.post.GetPostsByLocationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.post.GetPostsByLocationRequest}
 */
proto.social.post.GetPostsByLocationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLat(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLong(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOffset(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.post.GetPostsByLocationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.post.GetPostsByLocationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.post.GetPostsByLocationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.GetPostsByLocationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLat();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getLong();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional double lat = 1;
 * @return {number}
 */
proto.social.post.GetPostsByLocationRequest.prototype.getLat = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.GetPostsByLocationRequest} returns this
 */
proto.social.post.GetPostsByLocationRequest.prototype.setLat = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double long = 2;
 * @return {number}
 */
proto.social.post.GetPostsByLocationRequest.prototype.getLong = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.GetPostsByLocationRequest} returns this
 */
proto.social.post.GetPostsByLocationRequest.prototype.setLong = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 offset = 3;
 * @return {number}
 */
proto.social.post.GetPostsByLocationRequest.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.GetPostsByLocationRequest} returns this
 */
proto.social.post.GetPostsByLocationRequest.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.social.post.GetPostsByLocationRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.social.post.GetPostsByLocationRequest} returns this
 */
proto.social.post.GetPostsByLocationRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.social.post.TogglePost.prototype.toObject = function(opt_includeInstance) {
  return proto.social.post.TogglePost.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.social.post.TogglePost} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.TogglePost.toObject = function(includeInstance, msg) {
  var f, obj = {
    postId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.social.post.TogglePost}
 */
proto.social.post.TogglePost.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.social.post.TogglePost;
  return proto.social.post.TogglePost.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.social.post.TogglePost} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.social.post.TogglePost}
 */
proto.social.post.TogglePost.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.social.post.TogglePost.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.social.post.TogglePost.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.social.post.TogglePost} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.social.post.TogglePost.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPostId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string post_id = 1;
 * @return {string}
 */
proto.social.post.TogglePost.prototype.getPostId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.social.post.TogglePost} returns this
 */
proto.social.post.TogglePost.prototype.setPostId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool value = 2;
 * @return {boolean}
 */
proto.social.post.TogglePost.prototype.getValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.social.post.TogglePost} returns this
 */
proto.social.post.TogglePost.prototype.setValue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.social.post.RelatedType = {
  TO_POST: 0,
  TO_PRODUCT: 1,
  TO_STYLE: 2
};

goog.object.extend(exports, proto.social.post);
